import type {PermissionsRecordType} from '../permissions';

/** Stored calls (`CALL` resource): reading them and linking them to records. */
export const callPermissions = {
  callRead: {
    actionId: 'READ',
    resourceId: 'CALL',
    scopes: [],
  },
  callAssignRecord: {
    actionId: 'ASSIGN_RECORD',
    resourceId: 'CALL',
    scopes: [],
  },
  callUnassignRecord: {
    actionId: 'UNASSIGN_RECORD',
    resourceId: 'CALL',
    scopes: [],
  },
  callUpdateNote: {
    actionId: 'UPDATE_NOTE',
    resourceId: 'CALL',
    scopes: [],
  },
} satisfies PermissionsRecordType;
